// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { cashout as cashoutAction } from '../../actions/cashout';
import { setPreviousPage } from '../../actions/previouspages';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';
import { Routes } from '../../types/routes';

import HistoryItem from './HistoryItem';
import makeHistoryItemPropsSelector from './HistoryItem.selector';

type HistoryItemContainerProps = {
  className?: string;
  id: number; // betslipId
};

const HistoryItemContainer = (ownProps: HistoryItemContainerProps) => {
  const { id } = ownProps;
  const { history } = useRouter();
  const dispatch = useDispatch();

  const selectorProps = useMemo(() => ({ id, history }), [id, history]);
  const selector = useMemo(() => makeHistoryItemPropsSelector(), []);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { betslipReference, ...selectedProps } = useSelector((state) => selector(state, selectorProps));

  const cashout = useCallback(
    (id, expectedValue, cashoutAmount) => {
      dispatch(cashoutAction(id, expectedValue, cashoutAmount));
    },
    [dispatch],
  );

  const setPreviousPosition = useCallback(
    (pageNumber, anchorId) => setPreviousPage(Routes.HISTORY, { pageNumber, anchorId }),
    [],
  );

  const actions = useMemo(() => ({ setPreviousPosition }), [setPreviousPosition]);
  const actionsProps = useBindActionsCreator(actions);

  const otherProps = useMemo(() => ({ cashout }), [cashout]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps, otherProps });

  return <HistoryItem {...enhancedProps} />;
};

export default HistoryItemContainer;
